import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Modal,
  IconButton,
  Link,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { motion } from "framer-motion";

// {
//   image: require("../../assets/images/About/About-One.png"),
//   name: "Neeraj Verma",
//   position: "Co-Founder & CEO",
//   linkedinUrl: "https://www.linkedin.com/in/",
//   description:
//     "Mr. Neeraj Verma is the CEO and Director of Across Assist Private Limited (Formerly Bharti Assist Pvt. Ltd.). Across Assist, a rapidly growing assurance services company based in India. With over 20 years of experience in the banking and financial services industry, he has held pivotal roles at esteemed institutions such as ICICI Bank, Fullerton India, Citi, and Cholamandalam. Under his leadership, Across Assist has emerged as a leader in delivering innovative, customer-centric assurance solutions across sectors including travel, automotive, electronics, and healthcare.",
// },

const TEAM_MEMBERS = [
  {
    image: require("../../assets/images/About/About-Two.png"),
    name: "Sameer Madan",
    position: "Director",
    linkedinUrl: "https://www.linkedin.com/in/sameer-madan-2204aba/",
    description:
      "Sameer is a calm and decisive operations leader who balances profit, growth, and team harmony with a laser focus on customer satisfaction. With deep operational insight and wisdom, he leads from the front, navigating even the toughest business climates with clarity and confidence.",
  },
  {
    image: require("../../assets/images/About/About-Four.png"),
    name: "Ankur Aggarwal",
    position: "Chief Finance Officer",
    linkedinUrl:
      "https://www.linkedin.com/in/ankagarwal/?original_referer=https%3A%2F%2Facrossassist.com%2F",
    description:
      "Ankur is a strategic financial leader with a deep understanding of the tech and financial services sectors. He brings sharp decision-making, global business insight, and risk evaluation expertise to every table. As CFO, his precision drives growth and financial resilience.",
  },
  {
    image: require("../../assets/images/About/About-Five.png"),
    name: "Ankur Sawhney",
    position: "Head - Automobile Business",
    linkedinUrl: "https://www.linkedin.com/in/ankur-sawhney-49229616/",
    description:
      "Ankur is a seasoned professional with 14+ years of experience across Sales, Claims, Product Strategy, and Underwriting in the Health, Travel, and Personal Accident domains. He's a true auto industry insider and the driving force behind streamlined operations and customer-centric innovations in the automobile vertical.",
  },
  {
    image: require("../../assets/images/About/About-Seven.png"),
    name: "Mayank Mishra",
    position: "Head - Mobile Business",
    linkedinUrl: "https://www.linkedin.com/in/mayank-mishra-46326a23/",
    description:
      "Mayank is a retail and telecom veteran with over 22 years of experience in franchisee management, retail operations, sales strategy, and channel leadership. Known for his execution excellence and team-building acumen, Mayank's ability to connect authentically has made him a pioneer in appliance and gadgets networking.",
  },
  {
    image: require("../../assets/images/About/About-Three.png"),
    name: "Atul Sharma",
    position: "Head – Technology",
    linkedinUrl: "https://www.linkedin.com/in/atul-sharma-meta-insurance/",
    description:
      "Atul brings 12 years of rich experience across product innovation, customer engagement, and SaaS delivery. With hands-on experience in tech strategy, he's known for building scalable B2B/B2C solutions and fostering agile transformation across technology teams.",
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: (index) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: index * 0.15,
      duration: 0.4,
      ease: "easeOut",
    },
  }),
};

// const TeamCard = ({ member, index, onOpen }) => (
//   <motion.div
//     key={`${member.name}-${index}`}
//     custom={index}
//     initial="hidden"
//     whileInView="visible"
//     viewport={{ once: true, amount: 0.4 }}
//     variants={cardVariants}
//   >
//     <Card
//       sx={{
//         width: { xs: 250, sm: 250 },
//         maxWidth: "100%",
//         boxShadow: 0,
//         background: "#FFF",
//       }}
//     >
//       <CardMedia
//         component="img"
//         height="230"
//         image={member.image}
//         alt={member.name}
//         sx={{
//           objectFit: "scale-down",
//           borderRadius: "14px",
//           padding: "10px",
//         }}
//       />
//       <CardContent sx={{ textAlign: "center", py: 0 }}>
//         <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
//           {member.name}
//           <IconButton
//             color="primary"
//             onClick={() => onOpen(member)}
//             sx={{
//               bgcolor: "primary.light",
//               aspectRatio: 2 / 2,
//             }}
//           >
//             <InfoIcon
//               sx={{
//                 width: "20px",
//                 height: "20px",
//                 fontStyle: "italic",
//               }}
//             />
//           </IconButton>
//         </Typography>
//         <Typography variant="body2" color="text.secondary" sx={{ mb: 0 }}>
//           {member.position}
//         </Typography>
//       </CardContent>
//     </Card>
//   </motion.div>
// );

const TeamModal = ({ open, onClose, selectedMember }) => (
  <Modal
    open={open}
    onClose={onClose}
    aria-labelledby="team-member-modal"
    sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
  >
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
    >
      <Box
        sx={{
          bgcolor: "#fff",
          boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
          p: { xs: 3, sm: 4 },
          width: { xs: "90%", sm: "80%" },
          maxWidth: 900,
          borderRadius: 2,
          maxHeight: "90vh",
          overflowY: "auto",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 3,
          position: "relative",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "text.secondary",
            "&:hover": { color: "text.primary" },
          }}
        >
          <CloseIcon />
        </IconButton>

        {selectedMember && (
          <>
            <Box
              sx={{
                flex: "0 0 auto",
                width: { xs: "100%", sm: "40%" },
                maxWidth: 300,
              }}
            >
              <img
                src={selectedMember.image}
                alt={selectedMember.name}
                style={{
                  width: "100%",
                  height: "auto",
                  aspectRatio: "6 / 6",
                  borderRadius: "8px",
                  objectFit: "scale-down",
                }}
              />
            </Box>

            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                mt: { xs: 2, sm: 0 },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: { xs: "center", sm: "flex-start" },
                  gap: 1,
                }}
              >
                <Typography
                  id="team-member-modal"
                  variant="h5"
                  component="h2"
                  sx={{ fontWeight: 700 }}
                >
                  {selectedMember.name}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 400,
                    color: "text.secondary",
                    lineHeight: 1,
                  }}
                >
                  {selectedMember.position}
                </Typography>
                <Box sx={{ display: "flex", gap: 2 }}>
                  {selectedMember.linkedinUrl && (
                    <Link
                      href={selectedMember.linkedinUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        color: "#0077B5",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <LinkedInIcon />
                    </Link>
                  )}
                  {selectedMember.xLink && (
                    <Link
                      href={selectedMember.xLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        color: "#000",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <XIcon />
                    </Link>
                  )}
                </Box>
              </Box>

              <Typography variant="body1" sx={{ color: "text.secondary" }}>
                {selectedMember.description}
              </Typography>
            </Box>
          </>
        )}
      </Box>
    </motion.div>
  </Modal>
);

const TeamCarousel = ({ members }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const slideInterval = useRef(null);

  useEffect(() => {
    if (slideInterval.current) clearInterval(slideInterval.current);
    slideInterval.current = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === members.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);
    return () => clearInterval(slideInterval.current);
  }, [members.length]);

  const goToSlide = (idx) => {
    setCurrentIndex(idx);
  };

  const goToPrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? members.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === members.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <Box
      sx={{
        width: { xs: "100%", md: "80%" },
        mx: "auto",
        pb: 4,
        position: "relative",
        overflow: "hidden",
        borderRadius: 3,
        boxShadow: 0,
        background: "none",
        display: "flex",
        justifyContent: "center",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        minHeight: { xs: 400, md: 300 },
      }}
    >
      {/* Previous Arrow */}
      <IconButton
        onClick={goToPrev}
        sx={{
          position: "absolute",
          top: "50%",
          left: 10,
          transform: "translateY(-50%)",
          zIndex: 2,
          bgcolor: "white",
          boxShadow: 1,
          "&:hover": { bgcolor: "#e3e3e3" },
          display: { xs: "none", md: "flex" },
        }}
        aria-label="Previous"
      >
        <ArrowBackIosIcon />
      </IconButton>

      {/* Content Container with 60% width */}
      <Box
        sx={{
          width: "90%",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            flex: "0 0 252px",
            width: { xs: "100%", md: 320 },
            height: { xs: 220, md: 280 },
            display: "flex",
            alignItems: "start",
            justifyContent: "start",
            p: 2,
          }}
        >
          <CardMedia
            component="img"
            image={members[currentIndex].image}
            alt={members[currentIndex].name}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "fill",
              borderRadius: 2,
              boxShadow: 1,
              background: "#f5f5f5",
            }}
          />
        </Box>
        <Box
          sx={{
            flex: 1,
            p: { xs: 2, md: 3 },
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            minWidth: 0,
            alignItems: "start",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>
            {members[currentIndex].name}
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{ color: "text.secondary", mb: 1 }}
          >
            {members[currentIndex].position}
          </Typography>
          <Box sx={{ display: "flex", gap: 2, mb: 1 }}>
            {members[currentIndex].linkedinUrl && (
              <Link
                href={members[currentIndex].linkedinUrl}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: "#0077B5", display: "flex", alignItems: "start" }}
              >
                <LinkedInIcon />
              </Link>
            )}
            {members[currentIndex].xLink && (
              <Link
                href={members[currentIndex].xLink}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: "#000", display: "flex", alignItems: "center" }}
              >
                <XIcon />
              </Link>
            )}
          </Box>
          <Typography
            variant="body1"
            sx={{
              color: "text.secondary",
              alignItems: "start",
              textAlign: "left",
            }}
          >
            {members[currentIndex].description}
          </Typography>
        </Box>
      </Box>

      {/* Next Arrow */}
      <IconButton
        onClick={goToNext}
        sx={{
          position: "absolute",
          top: "50%",
          right: 10,
          transform: "translateY(-50%)",
          zIndex: 2,
          bgcolor: "white",
          boxShadow: 1,
          "&:hover": { bgcolor: "#e3e3e3" },
          display: { xs: "none", md: "flex" },
        }}
        aria-label="Next"
      >
        <ArrowForwardIosIcon />
      </IconButton>

      <Box
        sx={{
          position: "absolute",
          bottom: 12,
          left: 0,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          gap: 1,
        }}
      >
        {members.map((_, idx) => (
          <Box
            key={idx}
            onClick={() => goToSlide(idx)}
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              background: idx === currentIndex ? "#1E90FF" : "#cfd8dc",
              cursor: "pointer",
              transition: "background 0.3s",
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

const OurTeamsCards = () => {
  const [open, setOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  const handleOpen = (member) => {
    setSelectedMember(member);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedMember(null);
  };

  return (
    <>
      {/* <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          mt: 2,
          pb: 7,
          justifyContent: "center",
        }}
      >
        {TEAM_MEMBERS.map((member, index) => (
          <TeamCard
            key={`${member.name}-${index}`}
            member={member}
            index={index}
            onOpen={handleOpen}
          />
        ))}
      </Box> */}


      <TeamModal
        open={open}
        onClose={handleClose}
        selectedMember={selectedMember}
        sx={{
          pb: "3rem",
        }}
        />

        <div className="max-w-screen-xl mx-auto">
          <TeamCarousel members={TEAM_MEMBERS} />
        </div>
      </>
  );
};

export default OurTeamsCards;
